import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const JPFlag = createIcon({
  displayName: "JPFlag",
  viewBox: "0 0 96 64",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Japan flag </title>
      <path d="M96 0H0V64H96V0Z" fill="white" />
      <path
        d="M47.8984 51.0984C58.5023 51.0984 67.0984 42.5023 67.0984 31.8984C67.0984 21.2945 58.5023 12.6984 47.8984 12.6984C37.2946 12.6984 28.6984 21.2945 28.6984 31.8984C28.6984 42.5023 37.2946 51.0984 47.8984 51.0984Z"
        fill="#E20613"
      />
      <path
        d="M0 0V-1H-1V0H0ZM96 0H97V-1H96V0ZM96 64V65H97V64H96ZM0 64H-1V65H0V64ZM0 1H96V-1H0V1ZM95 0V64H97V0H95ZM96 63H0V65H96V63ZM1 64V0H-1V64H1Z"
        fill="#767676"
      />
    </>
  )
});
